var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStateSelectedicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9453 15.7969V17.7217H10.9834V21.5723H11.9453V23.4971H0.395508V21.5723H1.3584V17.7217H0.395508V15.7969L6.1709 13.8721L11.9453 15.7969ZM3.68164 3.28418H9.05859V8.63184L15.7959 14.3535V18.6846H20.5254L23.4961 21.6553V23.4971H22.6162L19.7285 20.6094H13.8711V15.2627L7.13281 9.54004V5.20898H2.88477L0.395508 2.71973V0.396484H0.793945L3.68164 3.28418ZM3.2832 17.7217V21.5723H5.20801V17.7217H3.2832ZM7.13281 17.7217V21.5723H9.05859V17.7217H7.13281ZM23.4961 2.32129V4.24609H22.5332V8.09668H23.4961V10.0215H11.9453V8.09668H12.9082V4.24609H11.9453V2.32129L17.7207 0.396484L23.4961 2.32129ZM14.833 4.24609V8.09668H16.7588V4.24609H14.833ZM18.6836 4.24609V8.09668H20.6084V4.24609H18.6836Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStateSelectedicon);
export default __webpack_public_path__ + "static/media/StateSelectedicon.d4b2a82e122cad57125898cfc5106b5d.svg";
export { ForwardRef as ReactComponent };